export default __webpack_public_path__ + "static/bg-c5e2984cd61cc01322b7a9033fffaa2f.png";